const i18n = require('i18n');
const State = require('PSState');
const GridSelector = require('GridSelector');

cc.Class({
    extends: cc.Component,

    properties: {
        gridSelector: GridSelector,
        startButton: cc.Button,
        winLimitValueLabel: cc.Label,
        lossLimitValueLabel: cc.Label,
        lossRequiredLabel: cc.Node,
        lossSlider: cc.Slider,
        winSlider: cc.Slider
    },

    onLoad () {
    },

    updateState () {
        if (!this.isGridInited) {
            this.isGridInited = true;
            this.gridSelector.init(State.availableNumberOfSpins,State.selectedSpinIndex, (selectedIndex) => {
                State.selectedSpinIndex = selectedIndex;
            });

            /** current design only fits 9 items
             * so we check if it exceeds 9, we increase the height of content with the correct amount
             */
            if (State.availableNumberOfSpins.length > 9) {
                const v = Math.ceil((State.availableNumberOfSpins.length - 9) / 3);

                this.node.children.forEach(child => {
                    const wgt = child.getComponent(cc.Widget);
                    if (wgt) {
                        wgt.top -= v*100;
                    } else {
                        child.height += v * 100;
                    }
                });
            }
        }
        // the values are betAmount dependent
        this._updateLossValue();
        this._updateWinValue();
    },

    onEnable () {
        if (this.lossSlider) {
            this.lossSlider.progress = 0;
        }
        if (this.winSlider) {
            this.winSlider.progress = 0;
        }

        this._updateWinValue();
        this._updateLossValue();
    },

    disableButtons () {
        this._isEnabled = false;
        this.startButton.interactable = false;
    },

    enableButtons () {
        this._isEnabled = true;
        this.startButton.interactable = true;
    },

    startAutoplay () {
        this.initialBalance = State.balance;
        this.node.emit('startAutoplay', State.availableNumberOfSpins[State.selectedSpinIndex]);
    },

    isInfinite () {
        return State.availableNumberOfSpins[State.selectedSpinIndex] === Number.MAX_SAFE_INTEGER;
    },

    hasMaxWinMet () {
        if (State.autoplaySelectedMaxWin === 0 || !this.initialBalance) {
            return false;
        }
        return (State.betWinning >= State.autoplaySelectedMaxWin);
    },
    hasMaxLossMet () {
        if (State.autoplaySelectedMaxLoss === 0 || !this.initialBalance) {
            return false;
        }
        return ((this.initialBalance - State.balance) >= State.autoplaySelectedMaxLoss);
    },

    reset () {
        this.initialBalance = null;
    },

    isAutoplay () {
        return State.autoplaySpinRemaining > 0;
    },

    onLossLimitSlider () {
        this._updateLossValue();
    },

    onWinLimitSlider () {
        this._updateWinValue();
    },

    _updateWinValue () {
        if (!this.winLimitValueLabel) { return };
        const maxWin = State.betAmount * State.autoplayMaxWinThreshold * this.winSlider.progress;
        State.autoplaySelectedMaxWin = Math.round((maxWin + Number.EPSILON) * 100) / 100;
        State.autoplaySelectedMaxWin = Math.round(State.autoplaySelectedMaxWin / State.betAmount) * State.betAmount;
        if (State.autoplaySelectedMaxWin > 0) {
            this.winLimitValueLabel.string = i18n.formatCurrency(State.autoplaySelectedMaxWin);
        } else {
            this.winLimitValueLabel.string = i18n.t('off');
        }
    },

    _updateLossValue () {
        if (!this.lossLimitValueLabel) { return };
        const maxLoss = State.betAmount * State.autoplayMaxLossThreshold * this.lossSlider.progress;
        State.autoplaySelectedMaxLoss = Math.round((maxLoss + Number.EPSILON) * 100) / 100;
        State.autoplaySelectedMaxLoss = Math.round(State.autoplaySelectedMaxLoss / State.betAmount) * State.betAmount;

        if (State.autoplaySelectedMaxLoss > 0) {
            this.lossLimitValueLabel.string = i18n.formatCurrency(State.autoplaySelectedMaxLoss);
            this.startButton.interactable = this._isEnabled;
            this.lossRequiredLabel.active = false;
        } else {
            this.startButton.interactable = false;
            this.lossLimitValueLabel.string = '';
            this.lossRequiredLabel.active = true;
        }
    },

});
